<script>
import {approvalApi} from "@/api/chemical";
import {ApprovalStatus, ApprovalType} from "./data/enums";

export default {
  name: 'ChemicalApprovalList',
  computed: {
    ApprovalStatus() {
      return ApprovalStatus
    },
    ApprovalType() {
      return ApprovalType
    }
  },
  data(){
    return {
      approvalList: [],
      current : 1,
      size: 30,
    }
  },
  mounted() {
    this.fetchApprovalList()
  },
  methods : {
    async fetchApprovalList() {
      const param = {
        current: this.current,
        size: this.size
      }
      const res  = await approvalApi.pageApprovalList(param)
      this.approvalList = res.result.records || []
    },
    handleDetail(row) {
      this.$router.push({
        name: 'chemicalApprovalDetail',
        params: {
          id: row.id
        }
      })
    }
  },
}

</script>

<template>
  <div>
    <el-card >
      <template #header>
        <span>审批列表</span>
      </template>
      <el-table :data="approvalList" border  stripe highlight-current-row>
        <el-table-column label="设备编码" prop="deviceCode"  />
        <el-table-column label="审批类型" prop="approvalTypeDesc" />
        <el-table-column label="审批状态" prop="statusDesc" />
        <el-table-column label="申请备注" prop="comment" min-width="120" show-overflow-tooltip  />
        <el-table-column label="申请时间" prop="createTime" min-width="120" show-overflow-tooltip  />
        <el-table-column label="审批结果" prop="resultTypeDesc" width="80" show-overflow-tooltip  />
        <el-table-column label="操作" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<style scoped>

</style>
